import React, {Component} from 'react';
import moment from 'moment';
import { browserHistory } from 'react-router';
import ButtonInput from '../Fields/ButtonInput';
import SubmitInput from '../Fields/SubmitInput';
import CheckboxInput from '../Fields/CheckboxInput';
import Field from '../Field';
import HeaderSteps from '../Fragments/HeaderSteps';
import MarketingPermissions from '../Fragments/MarketingPermissions';
import FullPageSpinner from '../Fragments/FullPageSpinner';

let HttpService = require('../Managers/HttpService');
let Quote = require('../Managers/Quote.js');
let envConfig = HttpService.getConfigForHost();
let brand = envConfig.configBrand;

export default class ResidenceDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tenantNumber: 1,
            isTermsModalVisible: false,
            isPhonePostModalVisible: false,
            applicationId: null,
            hasAgreedToTerms: null,
            rentalPropertyAddress: '',
            lettingAgentName: '',
            isPhoneAndPostChecked: true,
            isFullPageSpinnerActive: false,
        };
        this.inputComponents = [];
        this.childComponents = [];
    }

    componentWillMount() {
        // retrieve the agent branch details and setup state
        // variables so they can be rendered in the body text
        let agentPromise = HttpService.getRetrieveAgentBranch(HttpService.getLinkRef());
        let casePromise = HttpService.getRetrieveCase(Quote.get('caseId', 'BaseIndividualApplication'));

        Promise.all([agentPromise, casePromise]).then((data) => {
            if(data[0] && data[1]) {
                this.setState({
                    lettingAgentName: data[0].name,
                });

                // Save the ASN and tenancy term
                window.localStorage.setItem('ASN', data[0].agentSchemeNumber);
                window.localStorage.setItem('BankDataProvider', data[0].bankDataProvider);
                window.localStorage.setItem('TenancyTerm', data[1].tenancyTerm);

                // If the callback includes bankValidationMethod, then save it
                !window.uornorb(data[0].bankValidationMethod) ? window.localStorage.setItem('BankValidation', data[0].bankValidationMethod) : null;

                // Check against the tenancy start date - if it's more than 60
                // days in the future; set the employmentStatus to student, and
                // skip then we can skip the financial referees section.
                let tsd = moment(data[1].tenancyStartDate);
                let studentCutOff = moment().add(60, 'days');
                if (moment(tsd).isAfter(studentCutOff)) {
                    Quote.set('studentOnlyApplication', true, 'BaseIndividualApplication');
                    Quote.set('employmentStatus', 3, 'BaseIndividualApplication');
                }

                this.returnAddress(data[1].address);
            }
        })
        .then(() => {
            // Get the bank validation strategy data for this application's
            // originating agent, but only if we have a BankDataProvider stored
            // AND it's not 0.
            if (parseInt(window.localStorage.getItem('BankDataProvider')) != 0) {
                HttpService.getBankValidationStrategy();
            }
        });

        // Load in default checked state for marketing preferences for phone and
        // post, or set to the value we have in local storage.
        if (window.uornorb(Quote.getByPath('domainInfo.canContactApplicantByPhoneAndPost'))) {
            this.setState({ isPhoneAndPostChecked: false });
            Quote.setByPath('BaseIndividualApplication.canContactApplicantByPhoneAndPost', false);
        } else {
            this.setState({ isPhoneAndPostChecked: true });
            Quote.setByPath('BaseIndividualApplication.canContactApplicantByPhoneAndPost', true);
        }
    }

    componentDidMount() {
        $('html, body').animate({
            scrollTop: $('body').offset().top - $('header.site-header').height()
        }, 500);

        if (!window.uornorb(Quote.getByPath('domainInfo.termsAndConditions'))) {
            $('#terms').html(Quote.getByPath('domainInfo.termsAndConditions'));
        }
    }

    /**
     * Takes an address object and formats the values into an array then returns
     * it.
     */
    returnAddress(v) {
        let addressArray = [];

        v.flat ? addressArray.push(v.flat) : null;
        v.houseName ? addressArray.push(v.houseName) : null;
        v.houseNumber ? addressArray.push(v.houseNumber) : null;
        v.street ? addressArray.push(v.street) : null;
        v.locality ? addressArray.push(v.locality) : null;
        v.district ? addressArray.push(v.district) : null;
        v.town ? addressArray.push(v.town) : null;
        v.county ? addressArray.push(v.county) : null;
        v.country ? addressArray.push(v.country) : null;
        v.postcode ? addressArray.push(v.postcode) : null;

        this.setState({ rentalPropertyAddress: addressArray.join(', ')});
    }

    /**
     * Runs a replace() operation on a provided string, replacing tokens for the
     * letting agent name, and rental property address before returning the
     * updated string to display to the applicant-user.
     *
     * @param declaration
     * @returns String
     */
    filterDeclaration(declaration) {
        let tokens = [
            '{this.state.lettingAgentName}',
            '{this.state.rentalPropertyAddress}'
        ];
        let newDeclaration;

        newDeclaration = declaration.replace(new RegExp(tokens[0], "g"), this.state.lettingAgentName);
        newDeclaration = newDeclaration.replace(new RegExp(tokens[1], "g"), this.state.rentalPropertyAddress);

        return newDeclaration;
    }

    showTermsModal(e) {
        e.preventDefault();
        this.setState({ isTermsModalVisible: true });
    }

    closeModals(e) {
        e.preventDefault();
        this.setState({
            isTermsModalVisible: false,
            isPhonePostModalVisible: false,
        });
    }

    manualStepProgression() {
        this.setState({ isFullPageSpinnerActive: true });
        let inputComponents = [];

        this.childComponents.filter(c => {
            return (c !== undefined) && (c !== null);
        }).map(c => {
            inputComponents = inputComponents.concat(c.getChildInputComponents());
        });

        inputComponents = inputComponents.concat(this.inputComponents).filter(c => {
            return (c !== undefined) && (c !== null);
        });

        inputComponents.map(v => {
            v.getChildInstance().handleValidation(v.getChildInstance().getCurrentValue());
        });

        if (brand === 'Rentshield Direct' && window.uornorb(Quote.getByPath('BaseIndividualApplication.canContactThirdPartyBroadbandProvider'))) {
            this.setState({ isFullPageSpinnerActive: false });
            $('html, body').animate({
                scrollTop: $('#virginOptIn').offset().top - $('header.site-header').height()
            }, 500);
        } else if (!window.uornorb(Quote.getByPath('domainInfo.termsAndConditions'))) {
            if (Quote.getByPath('BaseIndividualApplication.agreedToTerms') === true) {
                this.setState({ hasAgreedToTerms: true });
                browserHistory.push('/application/your-details');
            } else {
                this.setState({ isFullPageSpinnerActive: false });
                this.setState({ hasAgreedToTerms: false });
                $('html, body').animate({
                    scrollTop: $('#agreeToTerms').offset().top - $('header.site-header').height()
                }, 500);
            }
        } else {
            browserHistory.push('/application/your-details');
        }
    }

    render() {
        const declaration = (!window.uornorb(Quote.getByPath('domainInfo.declaration'))) ? Quote.getByPath('domainInfo.declaration') : '';

        let FaCross = require('react-icons/lib/fa/close');
        return(
            <div>
                <HeaderSteps current={1} />
                <FullPageSpinner
                    isActive={this.state.isFullPageSpinnerActive}
                />

                <question-row className="no-border header-row">
                    <div className="question-main">
                        <h1>Before we start...</h1>
                        <p className="text--transform-uppercase">Important information, please read</p>
                        {!window.uornorb(Quote.getByPath('domainInfo.declaration')) ?
                            <div dangerouslySetInnerHTML={{__html: this.filterDeclaration(declaration)}} />
                        : null}
                        {!window.uornorb(Quote.getByPath('domainInfo.termsAndConditions')) ?
                            <p>Before we can commence your referencing you must read and agree to our <a className="underline" href="#" onClick={this.showTermsModal.bind(this)}><strong>terms and conditions</strong></a>.</p>
                        : null}
                    </div>
                </question-row>

                {!window.uornorb(Quote.getByPath('domainInfo.termsAndConditions')) ?
                    <div>
                        <Field
                            fieldName="agreeToTerms"
                            storageKey={'agreedToTerms'}
                            source={'BaseIndividualApplication'}
                            type="checkbox"
                            question="I agree"
                            isLabelFirst={false}
                            hasBorder={false}
                            hasPadding={false}
                        />
                        <question-row class="header-row">
                            {this.state.hasAgreedToTerms === false ?
                                <div className="error-container error-right">
                                    <div className={'content error'}>
                                        <div className="arrow" />
                                        <div className="error-content">
                                            <ul className="list-unstyled">
                                                <li>You must agree to the terms &amp; conditions in order to continue.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            : null}
                        </question-row>
                    </div>
                : null}

                {!window.uornorb(Quote.getByPath('domainInfo.termsAndConditions')) ?
                    <div>


                        <div className={this.state.isTermsModalVisible === true ? 'modal-container modal-active' : 'modal-container'}>
                            <div className="modal has-footer">
                                <div className="modal-header">
                                    Terms &amp; Conditions
                                    <div className="close-cross" onClick={this.closeModals.bind(this)}>
                                        <FaCross className="pointer" />
                                    </div>
                                </div>
                                <div className="modal-body">
                                    <div id="terms" className="content" />
                                </div>
                                <div className="modal-footer">
                                    <ButtonInput
                                        id="acceptTerms"
                                        buttonText="OK"
                                        classNames="btn-success"
                                        onClickEvent={this.closeModals.bind(this)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                : null}

                <div className="alternate-background">
                    <MarketingPermissions
                        showPhonePostModal={() => {
                            this.setState({ isPhonePostModalVisible: true });
                        }}
                    />

                    {!window.uorn(Quote.getByPath('domainInfo.thirdPartyUtilities')) ?
                        <question-row class="header-row" dangerouslySetInnerHTML={{__html: Quote.getByPath('domainInfo.thirdPartyUtilities')}} />
                    : null}

                    {brand === 'Rentshield Direct' ?
                        <div id={'virginOptIn'}>
                            <question-row>
                                <div className={'question-main'}>
                                    <h3>Do you want broadband, TV and/or phone ready for when you move in?</h3>
                                    <p>
                                        Well good news, we work with <strong>Virgin Media</strong> and <strong>Sky</strong> to get you great deals through our partnerships.<br />
                                        If you're applying as a guarantor we may still be able to provide you with discounted services for your property. All you need to do is opt in to receiving a call from their team below:
                                    </p>
                                </div>
                            </question-row>
                            <Field
                                question={''}
                                fieldName={'canContactThirdPartyBroadbandProvider'}
                                storageKey="canContactThirdPartyBroadbandProvider"
                                type="radio-group"
                                hasBorder={false}
                                hasPadding={false}
                                dataValidation="required_field"
                                options={[
                                    {
                                        value: true,
                                        text: 'Yes I would like to be contacted about the offers'
                                    },
                                    {
                                        value: false,
                                        text: 'No I would not like to be contacted about the offers'
                                    }
                                ]}
                                source="BaseIndividualApplication"
                                loadValues={false}
                                loadingKey={'BaseIndividualApplication.canContactThirdPartyBroadbandProvider'}
                                ref={(instance) => {this.inputComponents.push(instance);}}
                                columns={1}
                                inputExtra={'We can provide you with discounted offers you might not be able to access directly through Virgin Media or Sky.'}
                                questionBorder={true}
                                questionContent={'<img src="/images/vm-logo.png" width="100" /><img src="/images/sky-logo.png" width="100" />'}
                            />
                        </div>
                    : null}
                </div>

                <div className={this.state.isPhonePostModalVisible === true ? 'modal-container modal-active' : 'modal-container'}>
                    <div className="modal">
                        <div className="modal-header">
                            Don't Miss Out
                            <div className="close-cross" onClick={this.closeModals.bind(this)}>
                                <FaCross className="pointer" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="content">
                                <div className="row-2 uneven">
                                    <div className="column fixed">
                                        <img src="/images/Phone-and-Post.svg" className="marketing-selection-icon" />
                                        <div data-field="phone2">
                                            <CheckboxInput
                                                fieldName="marketingPreferencesTelephone"
                                                storageKey="canContactApplicantByPhoneAndPost"
                                                source="BaseIndividualApplication"
                                                question="Phone & Post"
                                                isDefaultChecked={this.state.isPhoneAndPostChecked ? true : false}
                                            />
                                        </div>
                                    </div>

                                    <div className="column">
                                        <p>We&rsquo;re experts in products and services for tenants. We won&rsquo;t share your personal data with anyone else for marketing purposes, so the only offers you&rsquo;ll get will be from us. If you&rsquo;d prefer that we didn&rsquo;t contact you with any further information by phone and post, please untick the box.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <ButtonInput
                                id="acceptTerms"
                                buttonText="CLOSE"
                                classNames="btn-default"
                                onClickEvent={this.closeModals.bind(this)}
                            />
                        </div>
                    </div>
                </div>

                <SubmitInput
                    label="Continue"
                    callbackFunction={this.manualStepProgression.bind(this)}
                    backLink={false}
                    saveForLater={false}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Screens/Declaration.js